<div class="search-filter-bar-wrapper">
  <div class="search-icon" tappable (click)="search()" [ngClass]="{ disabled: disabled }">
    <ion-icon name="alberta-search"></ion-icon>
  </div>
  <div class="searchbar-wrapper">
    <form (ngSubmit)="search()">
      <input
        data-testid="search-input"
        #searchInput
        [disabled]="disabled"
        class="searchbar"
        type="search"
        [placeholder]="placeholder"
        [(ngModel)]="value"
        [ngModelOptions]="{ standalone: true }"
      />
    </form>
    <div tappable class="cancel-button" (click)="resetSearch()" *ngIf="value">
      <ion-icon name="alberta-search-clear"></ion-icon>
    </div>
  </div>
  <ng-container *ngIf="showFilter">
    <itl-chip
      icon="alberta-filter"
      class="filter"
      *ngIf="!activeFilterArgs.length && !hasAnySpecialFilters"
      (click)="filterType()"
      [showDismiss]="false"
    >
      {{ 'patient.list.filter.filter' | translate }}
    </itl-chip>
    <ng-container *ngIf="!shouldShowCompactFilters">
      <ng-container *ngFor="let filter of activeFilterArgs">
        <itl-chip
          class="legacy-active-filter"
          (chipClicked)="filterType()"
          (dismissClicked)="dismissFilter.emit(filter)"
          [icon]="filterIcons[filter]"
        >
          {{ 'patient.list.filter.fields.' + filter | translate }}
        </itl-chip>
      </ng-container>
      <ng-container *ngIf="patientFilters?.lastVisit !== null && patientFilters?.lastVisit !== LastVisitChoice.anyTime">
        <itl-chip
          class="legacy-active-filter"
          (chipClicked)="filterType()"
          (dismissClicked)="dismissFilter.emit('lastVisit')"
          icon="alberta-activities"
        >
          <p>
            {{ 'patient.list.filter.lastVisit' | translate }}
          </p>
        </itl-chip>
      </ng-container>

      <ng-container *ngIf="patientFilters?.therapyId">
        <itl-chip
          class="legacy-active-filter"
          (chipClicked)="filterType()"
          (dismissClicked)="dismissFilter.emit('therapy')"
          [icon]="patientFilters.therapyId | therapyIconPipe"
          [style.color]="patientFilters.therapyId | therapyColor"
          [style.background-color]="patientFilters.therapyId | therapySecondaryColor"
          [style.border-color]="patientFilters.therapyId | therapyColor"
          [dismissBackgroundColor]="patientFilters.therapyId | therapyColor"
        >
          <p>
            {{
              patientFilters.therapyTypeId !== null
                ? (patientFilters.therapyTypeId | therapyType)
                : (patientFilters.therapyId | therapy)
            }}
          </p>
        </itl-chip>
      </ng-container>
      <ng-container *ngIf="patientFilters?.payerType">
        <itl-chip
          class="legacy-active-filter"
          (chipClicked)="filterType()"
          (dismissClicked)="dismissFilter.emit('payer')"
          icon="alberta-payer"
        >
          <p>
            {{
              patientFilters.payerId !== null
                ? ('patient.list.filter.payer' | translate)
                : ('patient.list.filter.payerType' | translate)
            }}
          </p>
        </itl-chip>
      </ng-container>
      <div *ngIf="totalFilterCount > 1" class="reset-filters" (click)="resetFilter.emit()">
        <ion-icon name="alberta-reset"></ion-icon>
      </div>
    </ng-container>
    <ng-container *ngIf="shouldShowCompactFilters">
      <itl-chip class="legacy-active-filter" icon="alberta-filter-multiple" (chipClicked)="filterType()">
        {{ 'patient.list.filter.fields.multiple' | translate }}
      </itl-chip>
    </ng-container>
  </ng-container>
</div>
